import * as React from "react";

const WarningAlertIcon = (props) => (
  <svg
    width={120}
    height={120}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_45515_65720)">
      <path
        d="M64.33 14.9998L111.96 97.4998C112.399 98.2599 112.63 99.1221 112.63 99.9998C112.63 100.877 112.399 101.74 111.96 102.5C111.521 103.26 110.89 103.891 110.13 104.33C109.37 104.769 108.508 105 107.63 105H12.37C11.4923 105 10.6301 104.769 9.87003 104.33C9.10996 103.891 8.47878 103.26 8.03996 102.5C7.60113 101.74 7.37011 100.877 7.37012 99.9998C7.37012 99.1221 7.60115 98.2599 8.03999 97.4998L55.67 14.9998C56.1088 14.2397 56.74 13.6086 57.5001 13.1698C58.2602 12.731 59.1223 12.5 60 12.5C60.8776 12.5 61.7398 12.731 62.4999 13.1698C63.2599 13.6086 63.8911 14.2397 64.33 14.9998V14.9998ZM55 79.9998V89.9998H65V79.9998H55ZM55 44.9998V69.9998H65V44.9998H55Z"
        fill="#FFCC00"
      />
    </g>
    <defs>
      <clipPath id="clip0_45515_65720">
        <rect width={120} height={120} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WarningAlertIcon;
